import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { isType, withFragments } from '@sorare/core/src/lib/gql';

import type { getTaskColors_taskInterface } from './__generated__/getTaskColors.graphql.ts';

export enum Colors {
  RED = 'RED',
  YELLOW = 'YELLOW',
  BLUE = 'BLUE',
}
export const getTaskColors = withFragments(
  (
    task: getTaskColors_taskInterface,
    featured?: boolean
  ): { borderColor: string | null } | null => {
    if (
      isType(task, 'ThresholdsStreakTask') ||
      isType(task, 'CardsCountTask') ||
      isType(task, 'CompleteCollectionsCountTask')
    ) {
      return null;
    }

    if (featured) {
      return {
        borderColor: task.color,
      };
    }

    return null;
  },
  {
    taskInterface: gql`
      fragment getTaskColors_taskInterface on TaskInterface {
        id
        color
      }
    ` as TypedDocumentNode<getTaskColors_taskInterface>,
  }
);
